var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "32px",
    viewBox: "0 0 38 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-51.000000, -1458.000000)",
    className: "premiumIcon",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1438.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "66.0588235 52 66.0588235 40.7058824 73.5882353 40.7058824 73.5882353 52 83 52 83 36.9411765 88.6470588 36.9411765 69.8235294 20 51 36.9411765 56.6470588 36.9411765 56.6470588 52"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home-blue.dd1029a765b42ee48e30623b78d2320d.svg";